var map = {
	"./en/candidate_dashboard.yaml": 47236,
	"./en/companies_accept_terms_of_use.yaml": 66737,
	"./en/companies_candidatos.yaml": 51788,
	"./en/companies_hub.yaml": 48636,
	"./en/companies_hub_salaries.yaml": 40891,
	"./en/companies_paused_package.yaml": 92641,
	"./en/companies_security_settings.yaml": 72955,
	"./en/companies_signup_flow.yaml": 32768,
	"./en/companies_subscription.yaml": 42921,
	"./en/criar_perfil_gratis.yaml": 98368,
	"./en/global.yaml": 79942,
	"./en/menu_header.yaml": 42976,
	"./en/plataform_footer.yaml": 45030,
	"./en/status_candidate_off_limits.yaml": 13074,
	"./en/tech_recruiter_signin.yaml": 21010,
	"./pt-BR/candidate_dashboard.yaml": 38593,
	"./pt-BR/companies_accept_terms_of_use.yaml": 30313,
	"./pt-BR/companies_candidatos.yaml": 60074,
	"./pt-BR/companies_hub.yaml": 50125,
	"./pt-BR/companies_hub_salaries.yaml": 1024,
	"./pt-BR/companies_paused_package.yaml": 63810,
	"./pt-BR/companies_security_settings.yaml": 92644,
	"./pt-BR/companies_signup_flow.yaml": 72432,
	"./pt-BR/companies_subscription.yaml": 58793,
	"./pt-BR/criar_perfil_gratis.yaml": 17074,
	"./pt-BR/global.yaml": 44226,
	"./pt-BR/menu_header.yaml": 79055,
	"./pt-BR/plataform_footer.yaml": 18569,
	"./pt-BR/status_candidate_off_limits.yaml": 34897,
	"./pt-BR/tech_recruiter_signin.yaml": 32146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26467;